import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M11 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m1.837 8.683.055.277a.86.86 0 0 1-.337.864 8.59 8.59 0 0 1-10.11 0 .86.86 0 0 1-.337-.864l.055-.277A5.2 5.2 0 0 1 7.266 13h.468c2.48 0 4.616 1.75 5.103 4.183"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14 8a1 1 0 0 1 1-1h3a4 4 0 0 1 0 8h-.586l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H18a2 2 0 0 0 0-4h-3a1 1 0 0 1-1-1",
      clipRule: "evenodd"
    }
  )
);
var SvgCallbackFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CallbackFilled_default = SvgCallbackFilled;

export { CallbackFilled_default as default };
